<template>
  <div class="block">
    <el-carousel height="1.56rem">
      <el-carousel-item v-for="(item, index) in items" :key="index">
        <img :src="item.url">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'swiper',
  props: ['items']
}
</script>

<style>
.block{
    width:100%;
    height:100%;
    position:relative;
}
.el-carousel__button{
    width:0.3rem;
}
</style>
